import React, { useEffect, useRef, useState } from 'react';

import PhoneInput, { Value } from 'react-phone-number-input';

import classNames from 'classnames';
import { CountryCode } from 'libphonenumber-js';

import ComponentType from '../../../types/Component';

import SelectPhoneField from './SelectPhoneField';
import styles from './styles.module.scss';

export type PhoneFieldProps = {
	onChange: (option: string, name: string) => void;
	name: string;
	value: string;
	error?: string;
	label?: string | JSX.Element;
	placeholder?: string;
	defaultCountry?: CountryCode;
};

const PhoneField: ComponentType<PhoneFieldProps> = ({
	value,
	onChange,
	name,
	error,
	label,
	defaultCountry,
	...rest
}) => {
	const [country, setCountry] = useState(defaultCountry);
	const inputRef = useRef<any>(null);

	useEffect(() => {
		if (error) {
			inputRef.current?.scrollIntoView({ block: 'center', behavior: 'smooth' });
		}
	}, [inputRef, error]);

	return (
		<div className={styles.PhoneField}>
			{typeof label === 'string' && <div className={styles.PhoneFieldLabel}>{label}</div>}
			{typeof label === 'object' && label}
			<PhoneInput
				id={'PhoneInput'}
				ref={inputRef}
				defaultCountry={country}
				onCountryChange={setCountry}
				countrySelectComponent={SelectPhoneField}
				countrySelectProps={{ searchable: true }}
				className={classNames({ error })}
				international={false}
				initialValueFormat="national"
				countryCallingCodeEditable={false}
				value={value as Value}
				onChange={(value) => onChange(value as string, name)}
				{...rest}
			/>
			{error && <div className={styles.PhoneFieldError}>{error}</div>}
		</div>
	);
};

export default PhoneField;
